import { useEffect } from "react";
import { Outlet, useLoaderData, useOutlet, useLocation } from "react-router-dom";

import AppWrapper from "../../../components/cm/AppWrapper";
import ClientDetail from "../../../components/cm/Dashboard/FullPages/ClientDetail";
import SideBarMain from "../../../components/cm/SideBarMain";
import { useHistoryNavigate } from "../../../hooks/useHistoryNavigate";

export default () => {
  const { _case, contactTypeBadges } = useLoaderData();
  const outlet = useOutlet();
  const location = useLocation();
  const { historyNavigate } = useHistoryNavigate();
  const isDocumentsRoute = location.pathname.includes("/documents");

  useEffect(() => {
    if (!outlet && !isDocumentsRoute) {
      historyNavigate("client-detail", _case?.id || _case?.pk);
    }
  }, [outlet, isDocumentsRoute, _case]);

  if (isDocumentsRoute) {
    return (
      <AppWrapper.WithSidebar sidebar={<SideBarMain />}>
        <Outlet />
      </AppWrapper.WithSidebar>
    );
  }

  return (
    <AppWrapper.WithSidebar sidebar={<SideBarMain />}>
      <ClientDetail _case={_case} contactTypeBadges={contactTypeBadges}>
        <Outlet />
      </ClientDetail>
    </AppWrapper.WithSidebar>
  );
};
